module.exports = __webpack_public_path__ + "static/line-drawing-dd61e3770ffba277d6e08e281c6676e0.gif";